// extracted by mini-css-extract-plugin
module.exports = {"imagePopOverRoot":"ImagesPopover_imagePopOverRoot__3LMzm","imagePopOverWrapper":"ImagesPopover_imagePopOverWrapper__CnR37","crossClose":"ImagesPopover_crossClose__sPh-U"};